import { BUSINESS } from "@/constants/business";

export default function Footer() {
  return (
    <footer data-testid="site-footer" className="bg-[var(--tt-charcoal)] text-[var(--tt-cream)]/80">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-10">
        <div>
          <div className="flex items-center gap-3">
            <img src="/assets/logo-cropped.jpg" alt="Tuncay Ticaret" className="w-12 h-12 rounded-lg bg-white p-1" />
            <div>
              <div className="font-display text-lg text-white">Tuncay Ticaret</div>
              <div className="text-[10px] uppercase tracking-[0.18em] text-[var(--tt-orange)]">Hırdavat & Geri Dönüşüm</div>
            </div>
          </div>
          <p className="text-sm mt-5 leading-relaxed">
            Kilis Merkez&apos;in güvenilir hırdavat ve geri dönüşüm adresi.
          </p>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-white font-bold mb-4">Hızlı Bağlantı</div>
          <ul className="space-y-2 text-sm">
            <li><a href="#about" className="hover:text-[var(--tt-orange)]">Hakkımızda</a></li>
            <li><a href="#services" className="hover:text-[var(--tt-orange)]">Hizmetler</a></li>
            <li><a href="#products" className="hover:text-[var(--tt-orange)]">Ürünler</a></li>
            <li><a href="#video" className="hover:text-[var(--tt-orange)]">Tanıtım Videosu</a></li>
            <li><a href="#contact" className="hover:text-[var(--tt-orange)]">İletişim</a></li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-white font-bold mb-4">İletişim</div>
          <ul className="space-y-2 text-sm">
            {BUSINESS.phones.map((p) => (
              <li key={p.whatsapp}>
                <a href={`tel:${p.tel}`} className="hover:text-[var(--tt-orange)]">
                  {p.display}
                </a>
              </li>
            ))}
            <li className="pt-2 text-[var(--tt-cream)]/60">{BUSINESS.address}</li>
          </ul>
        </div>

        <div>
          <div className="text-xs uppercase tracking-[0.2em] text-white font-bold mb-4">Hizmet Alanı</div>
          <p className="text-sm leading-relaxed">
            Kilis Merkez ve çevre ilçeler. Hurda alımı için adrese servis
            (talebe göre).
          </p>
        </div>
      </div>

      <div className="border-t border-white/10">
        <div className="max-w-7xl mx-auto px-5 sm:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-[var(--tt-cream)]/60">
          <div>© {new Date().getFullYear()} Tuncay Ticaret. Tüm hakları saklıdır.</div>
          <div>Kilis / Merkez • Türkiye</div>
        </div>
      </div>
    </footer>
  );
}
